export const SIZE_NAMES = {
  extraSmall: 'comp',
  small: 'low',
  medium: 'medium',
  large: 'high',
};

export default SIZE_NAMES;
